import InitialPlan01 from '../assets/images/userGuide/InitialPlan1.png';
import InitialPlan02 from '../assets/images/userGuide/InitialPlan2.png';
import InitialPlan03 from '../assets/images/userGuide/InitialPlan3.png';
import InitialPlan04 from '../assets/images/userGuide/InitialPlan4.png';
import InitialPlan05 from '../assets/images/userGuide/InitialPlan5.png';
import InitialPlan06 from '../assets/images/userGuide/InitialPlan6.png';
import MedicalBot1 from '../assets/images/userGuide/Medical1.png';

const userGuideImages = {
	InitialPlan01,
	InitialPlan02,
	InitialPlan03,
	InitialPlan04,
	InitialPlan05,
	InitialPlan06,
	MedicalBot1,
};

export default userGuideImages;
